export const SUBSCRIPTION_PAYMENT_LIST = "SUBSCRIPTION_PAYMENT_LIST";
export const SUBSCRIPTION_PAYMENT_APPROVE = "SUBSCRIPTION_PAYMENT_APPROVE";
export const SUBSCRIPTION_PAYMENT_REJECT = "SUBSCRIPTION_PAYMENT_REJECT";
export const OFFLINE_BANK_SETTINGS_GET = "OFFLINE_BANK_SETTINGS_GET";
export const OFFLINE_BANK_SETTINGS_UPDATE = "OFFLINE_BANK_SETTINGS_UPDATE";
